<template>
  <header class="PkiCertDetailsToolbar">
    <HeadingMedium
      class="certDetailsHeading"
      element="h1"
      :hasMargin="false"
    >
      Certificate Details
    </HeadingMedium>

    <div class="certDetailsActions">
      <IconButton
        class="btnExportCert"
        hasNoBackground
        icon="fileDownload"
        :isDisabled="isLoading"
        text="Export"
        type="informational"
        @click="handleExport"
      />

      <Button
        hasOutline
        :isDisabled="isLoading"
        text="Revoke"
        type="error"
        @click="handleRevoke"
      />
    </div>
  </header>
</template>

<script>
import {
  Button,
  HeadingMedium,
  IconButton,
} from '@jumpcloud/ui-components';

export default {
  name: 'PkiCertificateDetailsToolbar',

  components: {
    Button,
    HeadingMedium,
    IconButton,
  },

  data: () => ({
    isLoading: false, // @todo: toggle based on fetch status
  }),

  methods: {
    handleExport() {
      // @todo
    },

    handleRevoke() {
      // @todo
    },
  },
};
</script>

<style scoped>
.PkiCertDetailsToolbar {
  align-items: center;
  border-bottom: var(--jc-border);
  display: flex;
  justify-content: space-between;
  margin-right: var(--jc-spacer);
  padding: var(--jc-spacer);
}

.PkiCertDetailsToolbar .btnExportCert {
  margin-right: var(--jc-spacer);
}
</style>
